import React from "react";
import { connect } from "react-redux";
import withReportDataService from "../../hoc/with-dataservice-consumer";

const SignaturedPdfLink = ({ resultID, dataService, userName, loc }) => {
    const downLoadFile = (_url, fileName) => {
        fetch(_url, {
            headers: {
                ...dataService._authHeader().headers
            }
        })
            .then(res => res.blob())
            .then(myblob => {
                const a = document.createElement("a");
                a.style.display = "none";

                a.href = window.URL.createObjectURL(myblob);
                a.download = fileName;
                a.click();
                a.remove();
            })
            .catch();
    };

    const {
        user_sam,
        uri: { baseUrl },
        storageName
    } = dataService;
    const usrSamPar = `&_user=${user_sam ?? userName}`;
    // const fileName = `Report${resultID ? "_" + resultID.replace(".", "_") : ""}.pdf`;
    const href = `${baseUrl}SignedReportFile?ResultID=${resultID}${usrSamPar}&storageName=${storageName}`; //&inline=${}/${fileName}

    return (
        <div className="signaturedFile-info">
            <a
                className="signaturedFile-info__link"
                onClick={e => {
                    e.preventDefault();
                    downLoadFile(href); // , fileName
                }}
                href={href}
                // download
                rel="noopener noreferrer">
                {loc("links.downloadSignedFile")}
            </a>
        </div>
    );
};

const mapStateToProps = ({ oidc, reportApp: { reportData: { resultID, signInfo } = {} } }) => {
    return {
        resultID,
        signInfo,
        userName: oidc?.user?.profile?.name
    };
};
export default connect(mapStateToProps)(withReportDataService()(SignaturedPdfLink));
